module.exports = __webpack_public_path__ + "img/information-icon.2c7f172e.svg";